import React, {useCallback} from 'react';

export function More({children, handleEvent, classN}) {

  const clearFilter = useCallback(()=>(handleEvent()),[handleEvent]);

  return (
    <span
      onClick={clearFilter}
      className={`flex text-brand hover:underline hover:underline-offset-2 duration-500 ${classN} hover:decoration-brand lg:px-2 px-[1.35rem] py-3 text-sm items-center font-semibold cursor-pointer`}
    >
      {children}
    </span>
  );
}
